import React, { Component } from 'react'
import { Motion, spring } from 'react-motion'

type Props = {
  value: number,
  backgroundColor?: string,
  height?: number,
  className?: string,
  animate?: boolean
}

class ProgressBar extends Component<Props> {
  static defaultProps = {
    backgroundColor: 'blue',
    height: 24
  }

  renderProgressDiv (xValue: number) {
    const {
      backgroundColor,
      height,
      className
    } = this.props

    return (
      <div
        className={className}
        style={{
          height,
          backgroundColor,
          width: `${xValue}%`
        }}
      />
    )
  }

  render() {
    const {
      value,
      animate
    } = this.props

    return animate
      ? (
        <Motion
          defaultStyle={{x: 0}}
          style={{ x: spring(value) }}
        >
          {({ x }) =>
            this.renderProgressDiv(x)
          }
        </Motion>
      )
      : this.renderProgressDiv(value)
  }
}

export default ProgressBar



// WEBPACK FOOTER //
// ./src/components/ProgressBar/ProgressBar.js